import { useEffect, useState, useContext } from "react";
import { Chart } from "react-google-charts";
import { API } from "../../../API";
import { ShareAPI } from "../../../API";
import { useTranslation } from 'react-i18next';
import { BreakdownsContext } from "./contexts/BreakdownsContext";
import { BreakdownsContainer } from "../../../components/BreakdownsContainer/BreakdownsContainer";
import { LoaderSmall } from "../../../components/LoaderSmall/LoaderSmall";
import styles from '../NarrativePage.module.scss';
import { showRequestError } from '../../../utils/requestError';


export const Verification = ({narrative, isShare, isClickable=true, title}) => {
  const { t } = useTranslation();
  const [verification, setVerification] = useState(null);

  const {openModal, setTypesFilter, setCurrentWidgetName, setModalTitle} = useContext(BreakdownsContext);

  const api = isShare ? ShareAPI : API;

  const getNarrativeVerifications = () => {
    const urlParams = new URLSearchParams();
    urlParams.set('widget_name', `verification_breakdown`);
    api.fetch('GET', `/API/v1/narratives/${narrative.id}/verifications?${urlParams.toString()}`).then(
      data => setVerification(data)
    ).catch(e => { showRequestError(e, t('Verification')); setVerification([]); })
  }

  useEffect(() => {
    getNarrativeVerifications()
  }, [narrative.id])

  const getNotVerifiedCount = (verification) => {
    let notVerified = verification?.objects.filter(item => item.name !== 'verified');
    let count = notVerified.reduce((accumulator, currentValue) => accumulator + currentValue.count, 0);
    return count;
  }

  const getVerifiedCount = (verification) => {
    let verified = verification?.objects.filter(item => item.name === 'verified');
    let count = verified[0]?.count;
    return count;
  }

  const getChartData = (verification) => {
    let data = [
      ['Actor', 'Count']
    ]
    let verCount = getVerifiedCount(verification);
    let notVerCount = getNotVerifiedCount(verification);

    data.push([t('Verified'), verCount])
    data.push([t('Not verified'), notVerCount])
    return data;
  }

  const mapIndexToValue = {
    0: 'true',
    1: 'false'
  }

  const options = {
    colors: ['#186ADE', '#B5C9F6'], 
    tooltip: { showColorCode: true }, 
    legend: {
      position: 'labeled', 
      textStyle: { fontSize: 16, },
    },
    chartArea: { left: '5%', top: '20%', width:'95%', height:'75%' },
    pieSliceText: 'value',
    slices: { 0: {offset: 0.05} },
  }

  return(
    <BreakdownsContainer
      title={title ? title : 'Verification'}
      onClick={() => openModal()}
      flexGrow='2'
      details={false}
    >
      <div className={styles.chartWrapper} translate="no">
        {verification ? (verification.objects?.length > 0 
        ? <Chart
          chartType="PieChart"
          data={getChartData(verification)}
          width={"95%"}
          height={"350px"}
          className='pieChart'
          options={options}
          chartEvents={
            isClickable
            ? [
              {
                eventName: "select",
                callback({ chartWrapper }) {
                  // getChart() is null when a click lands mid-redraw (OSAVUL-FRONTEND-G9)
                  let selected = chartWrapper.getChart()?.getSelection();
                  if (!selected?.length) return;
                  let index = selected[0]?.row;
                  if (index == null) return;
                  let option = {value: 'is_verified', label: 'Verified', bool: mapIndexToValue[index]}
                  setTypesFilter(option)
                  setCurrentWidgetName('verification_breakdown')
                  setModalTitle(index === 0 ? t('Verified') : t('Not verified'))
                  openModal()
                }
              }
            ]
            : []
          }
          
          style={{margin: '0px', padding: '0px'}}
          
        /> 
        : <div className={styles.noData}>{t('There is no data to display')}</div>
        ) : <div className={styles.widdgetLoader}><LoaderSmall /></div>}
      </div>
      
    </BreakdownsContainer>
  )
}

